import { createAction } from '@reduxjs/toolkit';

import { UPDATE_LANGUAGE } from 'constants/redux-actions';

const updateLanguage = (langId) => createAction(UPDATE_LANGUAGE)(langId);

const langActions = { updateLanguage };

export default langActions;
